import axios from 'axios';

import {API_URL_V2, getContentType} from './api.config';
import {deduplicateGetRequests} from './get-request-deduplicator';

const axiosInstance = axios.create({
  baseURL: API_URL_V2,
  headers: getContentType(),
  withCredentials: true,
});

deduplicateGetRequests(axiosInstance);

export default axiosInstance;
